(function(){
function scalarSpec(value) {
  if (typeof value === "number") return Number.isFinite(value) ? value : null;
  if (typeof value !== "string" || !/^[+-]?(?:\d+(?:\.\d*)?|\.\d+)$/.test(value.trim())) return null;
  const n=Number(value);return Number.isFinite(n)?n:null;
}

function canonicalPattern(value) {
  if (typeof value!=="string") return null;
  const m=value.trim().match(/^(\d+)\s*[x×]\s*(\d+(?:\.\d+)?)$/i);
  if(!m)return null;
  const holes=Number(m[1]),pcd=Number(m[2]);
  if(!Number.isSafeInteger(holes)||holes<3||holes>12||pcd<40||pcd>400)return null;
  return holes+"x"+pcd;
}

function parseCatalogVariant(raw) {
  const issues=[];
  const fail=reason=>({variant:null,issue:{id:raw?.id,sku:raw?.sku,title:raw?.product?.title,reason,options:raw?.selectedOptions}});
  if(!raw||!Array.isArray(raw.selectedOptions)||typeof raw.id!=="string"||!/^gid:\/\/shopify\/ProductVariant\/\d+$/.test(raw.id))return fail("Invalid variant identity or options");
  const opts={};
  for(const o of raw.selectedOptions){
    if(typeof o.name!=="string"||typeof o.value!=="string")return fail("Malformed options");
    const name=o.name.trim().toLowerCase().replace(/\s+/g," ");
    if(name in opts)return fail("Duplicate option name");
    opts[name]=o.value.trim();
  }
  const size=opts.size||"";
  if(/\b(driver|passenger|left|right)\b/i.test(size))return fail("Directional wheel: paired sides require separate handling");
  const sm=size.match(/^(\d+(?:\.\d+)?)\s*[x×]\s*(\d+(?:\.\d+)?)$/i);
  if(!sm)return fail("Size is missing, custom, or not a fixed diameter × width");
  const diameter=Number(sm[1]),width=Number(sm[2]);
  if(!(diameter>0&&width>0))return fail("Nonpositive wheel dimensions");
  let pcd=opts.pcd,et=opts.et;
  if(opts["pcd et"]){
    const combined=opts["pcd et"].match(/^PCD:\s*(.*?)\s+ET:\s*(.*?)$/i);
    if(!combined||pcd!==undefined||et!==undefined)return fail("Ambiguous combined PCD / ET");
    [,pcd,et]=combined;
  }
  if(typeof pcd!=="string"||typeof et!=="string")return fail("Missing PCD or ET");
  const offset=scalarSpec(et.replace(/\s*mm\s*$/i,""));
  if(offset===null)return fail("ET is missing, custom, or a range");
  const inchPCDs={"4.5":114.3,"4.75":120.65,"5":127,"5.5":139.7,"6.5":165.1};
  const parts=pcd.split("/");
  if(!parts.length)return fail("Missing PCD");
  const patterns=[];
  for(const part of parts){
    const m=part.trim().match(/^(\d+)\s*[x×]\s*(\d+(?:\.\d+)?)$/i);
    if(!m)return fail("PCD is custom or ambiguous");
    const numeric=Number(m[2]);
    const mm=numeric<20?inchPCDs[String(numeric)]:numeric;
    const pattern=mm===undefined?null:canonicalPattern(m[1]+"x"+mm);
    if(!pattern)return fail("Unsupported PCD notation");
    if(!patterns.includes(pattern))patterns.push(pattern);
  }
  const handle=raw.product?.handle,id=raw.id.split("/").pop();
  if(typeof handle!=="string"||!/^[a-z0-9][a-z0-9-]*$/.test(handle))return fail("Invalid product handle");
  return {variant:{
    id,sku:raw.sku||"",price:raw.price,available:raw.availableForSale===true,
    diameter,width,offset,patterns,finish:opts.finish||null,
    product:{...raw.product},
    productUrl:"https://www.wheelsoutlet.com/products/"+handle+"?variant="+id
  },issue:null};
}

function matchBasicWheelCandidates(vehicle, variants) {
  const dimensions = value=>{
    if(!value||typeof value!=="object"||Array.isArray(value)||value.staggered===true||value.setup==="staggered")return null;
    const diameter=scalarSpec(value.diameter),width=scalarSpec(value.width),offset=scalarSpec(value.offset);
    return diameter!==null&&diameter>0&&width!==null&&width>0&&offset!==null?{diameter,width,offset}:null;
  };
  const boltPattern=canonicalPattern(vehicle?.boltPattern);
  if(!boltPattern||!Array.isArray(vehicle?.wheels)||!Array.isArray(variants))throw new TypeError("Normalized vehicle and variant data required");
  const refs=vehicle.wheels.flatMap((source,index)=>{const d=dimensions(source);return d?[{...d,stock:source.stock===true,index,source}]:[]});
  if(!refs.length)throw new TypeError("No complete same-size vehicle wheel reference");
  const candidates=[];
  for(const v of variants){
    const spec=dimensions(v);
    if(!spec||typeof v.id!=="string"||!/^\d+$/.test(v.id)||!v.available||v.available!==true||v.product?.status!=="ACTIVE"||!v.product?.onlineStoreUrl)continue;
    if(!Array.isArray(v.patterns))continue;
    const patterns=v.patterns.map(canonicalPattern);
    if(patterns.some(p=>!p)||!patterns.includes(boltPattern))continue;
    let best=null;
    for(const ref of refs){
      if(spec.diameter!==ref.diameter)continue;
      const half=(spec.width-ref.width)*12.7,outwardMm=half+ref.offset-spec.offset,inwardMm=half+spec.offset-ref.offset;
      if(!Number.isFinite(outwardMm)||!Number.isFinite(inwardMm)||outwardMm>25+1e-9||inwardMm>15+1e-9)continue;
      const score=Math.abs(outwardMm)+Math.abs(inwardMm);
      if(!best||score<best.score||(score===best.score&&ref.stock&&!best.reference.stock))best={reference:ref,outwardMm,inwardMm,score};
    }
    if(best)candidates.push({classification:"suggested",variant:v,specification:{...spec,boltPattern},...best,limits:{outwardMm:25,inwardMm:15}});
  }
  candidates.sort((a,b)=>a.specification.diameter-b.specification.diameter||a.specification.width-b.specification.width||a.specification.offset-b.specification.offset||a.variant.id.localeCompare(b.variant.id));
  return candidates;
}


// Existing exact matches are retained. Only new, larger-diameter suggestions use
// this opt-in policy; the result remains a geometric suggestion, not verified fit.
function normalizePlusSizePolicy(options = {}) {
  if (!options || typeof options !== 'object' || Array.isArray(options)) {
    throw new TypeError('Plus-size options must be an object.');
  }
  if (Object.keys(options).some(key => key !== 'maxDiameterIncrease')) {
    throw new TypeError('Use the maxDiameterIncrease option.');
  }
  const increase = options.maxDiameterIncrease;
  if (increase !== undefined && increase !== 1 && increase !== 2) {
    throw new TypeError('maxDiameterIncrease must be 1 or 2 inches when provided.');
  }
  return {maxDiameterIncrease: increase === undefined ? 0 : increase, anchorPolicy: 'maximum-stock-or-smallest-listed'};
}

function plusSizeDimensions(value) {
  if (!value || typeof value !== 'object' || Array.isArray(value) ||
      value.staggered === true || value.setup === 'staggered') return null;
  const diameter = scalarSpec(value.diameter);
  const width = scalarSpec(value.width);
  const offset = scalarSpec(value.offset);
  return diameter !== null && diameter > 0 && width !== null && width > 0 &&
    offset !== null ? {diameter, width, offset} : null;
}

function matchPlusSizeWheelCandidates(vehicle, variants, options = {}) {
  const policy = normalizePlusSizePolicy(options);
  // This also applies the original input validation and preserves exact behavior.
  const exact = matchBasicWheelCandidates(vehicle, variants);
  if (policy.maxDiameterIncrease === 0) return exact;

  const boltPattern = canonicalPattern(vehicle.boltPattern);
  const references = vehicle.wheels.flatMap((source, index) => {
    const dimensions = plusSizeDimensions(source);
    return dimensions ? [{...dimensions, stock: source.stock === true, index, source}] : [];
  });
  const stock = references.filter(reference => reference.stock);
  const ceilingReferenceDiameter = stock.length
    ? Math.max(...stock.map(reference => reference.diameter))
    : Math.min(...references.map(reference => reference.diameter));
  const maxDiameter = ceilingReferenceDiameter + policy.maxDiameterIncrease;
  // Factory references share a ceiling based on the largest factory diameter.
  // Keep smaller factory references for intermediate sizes and geometry checks.
  // Without factory data, retain the smallest-listed fallback; never chain from
  // a larger listed alternative to expand the permitted diameter range.
  const anchors = stock.length ? stock : references.filter(reference =>
    reference.diameter === ceilingReferenceDiameter);
  const referenceBasis = stock.length ? 'stock' : 'listed';
  const exactVariants = new Set(exact.map(candidate => candidate.variant));
  const candidates = exact.slice();
  const epsilon = 1e-9;

  for (const variant of variants) {
    if (exactVariants.has(variant)) continue;
    const specification = plusSizeDimensions(variant);
    if (!specification || typeof variant.id !== 'string' || !/^\d+$/.test(variant.id) ||
        variant.available !== true || variant.product?.status !== 'ACTIVE' ||
        !variant.product?.onlineStoreUrl || !Array.isArray(variant.patterns)) continue;
    if (specification.diameter > maxDiameter + epsilon) continue;
    const patterns = variant.patterns.map(canonicalPattern);
    if (patterns.some(pattern => !pattern) || !patterns.includes(boltPattern)) continue;

    let best = null;
    for (const reference of anchors) {
      const diameterIncrease = specification.diameter - reference.diameter;
      // A plus-size comparison can never derive a smaller or same-diameter wheel.
      if (!(diameterIncrease > epsilon)) continue;
      const halfWidthDifference = (specification.width - reference.width) * 12.7;
      const outwardMm = halfWidthDifference + reference.offset - specification.offset;
      const inwardMm = halfWidthDifference + specification.offset - reference.offset;
      // Both limits must pass against this same square reference.
      if (!Number.isFinite(outwardMm) || !Number.isFinite(inwardMm) ||
          outwardMm > 25 + epsilon || inwardMm > 15 + epsilon) continue;
      const score = Math.abs(outwardMm) + Math.abs(inwardMm);
      if (!best || score < best.score ||
          (score === best.score && diameterIncrease < best.diameterIncrease)) {
        best = {reference, outwardMm, inwardMm, score, diameterIncrease};
      }
    }
    if (!best) continue;
    candidates.push({
      classification: 'suggested',
      variant,
      specification: {...specification, boltPattern},
      reference: best.reference,
      outwardMm: best.outwardMm,
      inwardMm: best.inwardMm,
      score: best.score,
      limits: {outwardMm: 25, inwardMm: 15},
      diameterIncrease: best.diameterIncrease,
      referenceBasis,
      rule: 'plus-size',
      ruleLabel: 'Diameter up to ' + maxDiameter + ' inches (' +
        (stock.length ? 'maximum stock' : 'smallest listed') + ' reference + ' + policy.maxDiameterIncrease + ')',
      sizing: {
        type: 'plus-size',
        diameterIncreaseInches: best.diameterIncrease,
        maxIncreaseInches: policy.maxDiameterIncrease,
        ceilingReferenceDiameterInches: ceilingReferenceDiameter,
        maxDiameterInches: maxDiameter,
        referenceBasis
      }
    });
  }
  candidates.sort((a, b) =>
    a.specification.diameter - b.specification.diameter ||
    a.specification.width - b.specification.width ||
    a.specification.offset - b.specification.offset ||
    a.variant.id.localeCompare(b.variant.id)
  );
  return candidates;
}



/**
 * Filter categories only. Keep the catalog finish unchanged for product labels,
 * swatches, images and variant links. A mixed finish may belong to many groups.
 */
const FINISH_FILTER_COLORS = ['Black', 'Silver', 'Gold', 'White'];

function finishFilterGroups(exactFinish) {
  if (typeof exactFinish !== 'string') return [];
  const label = exactFinish.trim();
  if (!label) return [];
  const lowercase = label.toLowerCase();
  // Literal substring matching is intentional: no token boundaries or aliases.
  const groups = FINISH_FILTER_COLORS.filter(color =>
    lowercase.includes(color.toLowerCase()));
  return groups.length ? groups : [label];
}

function finishFilterOptions(finishes = []) {
  if (!Array.isArray(finishes)) {
    throw new TypeError('Finish values must be an array.');
  }
  return [...new Set(finishes.flatMap(finishFilterGroups))]
    .sort((a, b) => a.localeCompare(b));
}

function finishMatchesFilter(exactFinish, selectedGroups = []) {
  if (!Array.isArray(selectedGroups) && !(selectedGroups instanceof Set)) {
    throw new TypeError('Selected finish groups must be an array or Set.');
  }
  const selected = selectedGroups instanceof Set ? selectedGroups : new Set(selectedGroups);
  if (selected.size === 0) return true;
  return finishFilterGroups(exactFinish).some(group => selected.has(group));
}



const FAST_CATALOG_SCHEMA = 'wo-fitment-catalog-v1';
const FAST_PRODUCT_SCHEMA = 'wo-fitment-product-v1';
const FAST_STORE_ORIGINS = new Set(['https://www.wheelsoutlet.com', 'https://wheelsoutlet.com']);
function catalogError(message) { return new Error(message || 'The current wheel catalog could not be loaded. Please try again.'); }
function catalogAssert(ok, message) { if (!ok) throw catalogError(message); }
function catalogInteger(n, minimum = 0, maximum = 25000) { return Number.isSafeInteger(n) && n >= minimum && n <= maximum; }
function catalogId(id) { return typeof id === 'string' && /^[1-9]\d{0,23}$/.test(id); }
function catalogHandle(handle) { return typeof handle === 'string' && /^[a-z0-9][a-z0-9-]{0,239}$/.test(handle); }
function catalogImage(image, origin = 'https://www.wheelsoutlet.com') {
  if (!image || typeof image.src !== 'string') return null;
  try {
    const url = new URL(image.src, origin);
    if (url.protocol !== 'https:' || url.username || url.password) return null;
    if (!['cdn.shopify.com', 'www.wheelsoutlet.com', 'wheelsoutlet.com', 'wheelsoutlet-2.myshopify.com'].includes(url.hostname) && !url.hostname.endsWith('.shopifycdn.com')) return null;
    return {src: url.href, alt: typeof image.alt === 'string' ? image.alt.slice(0,800) : ''};
  } catch { return null; }
}
function catalogVariantIdentity(variants, total) {
  catalogAssert(Array.isArray(variants) && catalogInteger(total, 0, 10000), 'The wheel catalog has an invalid variant count.');
  const seen = new Set();
  for (const v of variants) {
    catalogAssert(v && catalogId(v.id) && !seen.has(v.id), 'The wheel catalog contains missing or repeated variant records.');
    seen.add(v.id);
  }
}
function validateFastCatalogPage(payload, expectedPage, expectedCollection) {
  catalogAssert(payload && payload.schema === FAST_CATALOG_SCHEMA, 'The fast wheel catalog is not available in this theme yet.');
  catalogAssert(typeof payload.currency === 'string' && /^[A-Z]{3}$/.test(payload.currency), 'The wheel catalog currency is missing.');
  catalogAssert(catalogHandle(payload.collection) && (!expectedCollection || payload.collection === expectedCollection), 'A different collection was returned.');
  catalogAssert(catalogInteger(payload.totalProducts) && catalogInteger(payload.pageSize, 1, 250), 'The wheel catalog page count is invalid.');
  const pages = Math.max(1, Math.ceil(payload.totalProducts / payload.pageSize));
  catalogAssert(payload.pages === pages || (payload.totalProducts === 0 && payload.pages === 0), 'The wheel catalog is incomplete.');
  catalogAssert(payload.page === expectedPage && catalogInteger(payload.page, 1, pages), 'A different wheel catalog page was returned.');
  const expectedCount = Math.min(payload.pageSize, Math.max(0, payload.totalProducts - (payload.page - 1) * payload.pageSize));
  catalogAssert(Array.isArray(payload.products) && payload.products.length === expectedCount, 'The wheel catalog page was truncated. Please try again.');
  for (const p of payload.products) {
    catalogAssert(p && catalogId(p.id) && catalogHandle(p.handle), 'The wheel catalog contains an invalid product.');
    catalogVariantIdentity(p.variants, p.variantsCount);
    catalogAssert(p.variantsReturned === p.variants.length && p.variants.length <= Math.min(p.variantsCount, 250), 'The wheel catalog contains an incomplete variant list.');
  }
  return {...payload, pages};
}
function validateFastProductPage(payload, expectedPage, descriptor, currency) {
  catalogAssert(payload && payload.schema === FAST_PRODUCT_SCHEMA, 'The remaining wheel options could not be loaded.');
  catalogAssert(payload.id === descriptor.id && payload.handle === descriptor.handle && payload.currency === currency, 'Different wheel options were returned.');
  catalogAssert(payload.variantsCount === descriptor.variantsCount && catalogInteger(payload.pageSize, 1, 50), 'The wheel options changed while loading. Please try again.');
  const pages = Math.max(1, Math.ceil(descriptor.variantsCount / payload.pageSize));
  catalogAssert(payload.pages === pages && payload.page === expectedPage && catalogInteger(payload.page, 1, pages), 'The remaining wheel options are incomplete.');
  catalogVariantIdentity(payload.variants, descriptor.variantsCount);
  const expectedCount = Math.min(payload.pageSize, descriptor.variantsCount - (payload.page - 1) * payload.pageSize);
  catalogAssert(payload.variantsReturned === payload.variants.length && payload.variants.length === expectedCount, 'A wheel option page was truncated.');
  return payload;
}
function normalizeFastCatalogProduct(raw, currency, origin) {
  catalogAssert(raw.variants.length === raw.variantsCount, 'A wheel has unresolved variant pages.');
  const vendor = typeof raw.vendor === 'string' ? raw.vendor : '';
  const type = typeof raw.type === 'string' ? raw.type : '';
  if (!['wheel', 'wheels'].includes(type.toLowerCase()) && !['vors','mrr'].includes(vendor.toLowerCase())) return {product:null, variants:[], excluded:0};
  const image = catalogImage(raw.image, origin);
  const images = Array.isArray(raw.images) ? raw.images.map(i=>catalogImage(i, origin)).filter(Boolean) : [];
  const options = Array.isArray(raw.options) ? raw.options : [];
  const product = {
    id:'gid://shopify/Product/'+raw.id, handle:raw.handle,
    title:typeof raw.title === 'string' ? raw.title : raw.handle, vendor,
    productType:type, status:'ACTIVE', onlineStoreUrl:origin+'/products/'+raw.handle,
    image, images, options, variantsCount:raw.variantsCount
  };
  const variants = []; let excluded = 0;
  let finishIndex = options.findIndex(o=>typeof o === 'string' && o.trim().toLowerCase() === 'finish');
  if (finishIndex < 0) finishIndex = options.findIndex(o=>typeof o === 'string' && /^(color|colour)$/i.test(o.trim()));
  const finishValues = new Set(raw.variants.flatMap(v=>Array.isArray(v.options) && typeof v.options[finishIndex] === 'string' ? [v.options[finishIndex].trim().toLowerCase()] : []));
  const singleFinish = finishIndex < 0 || finishValues.size === 1;
  const finishImages = new Map();
  for (const rawVariant of raw.variants) {
    const i = catalogImage(rawVariant.image, origin);
    const f = finishIndex >= 0 && Array.isArray(rawVariant.options) ? rawVariant.options[finishIndex] : null;
    if (i && typeof f === 'string' && !finishImages.has(f.trim().toLowerCase())) finishImages.set(f.trim().toLowerCase(), i);
  }
  for (const v of raw.variants) {
    if (v.available !== true) continue;
    if (!catalogInteger(v.price, 0, Number.MAX_SAFE_INTEGER) || options.length < 1 || options.length > 3 || !Array.isArray(v.options) || v.options.length !== options.length) { excluded++; continue; }
    const parsed = parseCatalogVariant({
      id:'gid://shopify/ProductVariant/'+v.id, sku:typeof v.sku === 'string' ? v.sku : '',
      price:(v.price/100).toFixed(2), availableForSale:true,
      selectedOptions:options.map((name,i)=>({name:i === finishIndex ? 'Finish' : name,value:v.options[i]})), product
    });
    if (!parsed.variant) { excluded++; continue; }
    const exactImage = catalogImage(v.image, origin) || (parsed.variant.finish ? finishImages.get(parsed.variant.finish.trim().toLowerCase()) : null) || (singleFinish ? image : null);
    variants.push({...parsed.variant, currency, backorder:v.backorder === true, image:exactImage,
      productUrl:origin+'/products/'+raw.handle+'?variant='+v.id});
  }
  return {product, variants, excluded};
}
function normalizeFastCatalogPages(pages, overflowPages = new Map(), origin = 'https://www.wheelsoutlet.com') {
  catalogAssert(FAST_STORE_ORIGINS.has(origin), 'Use Wheels Outlet to load the wheel catalog.');
  catalogAssert(Array.isArray(pages) && pages.length, 'The wheel catalog is empty or incomplete.');
  const first = validateFastCatalogPage(pages.find(p=>p?.page===1), 1);
  catalogAssert(pages.length === first.pages, 'Not all wheel catalog pages were loaded.');
  const products = [], variants = [], seenProducts = new Set(), seenVariants = new Set(); let excluded = 0;
  for (let page = 1; page <= first.pages; page++) {
    const matches = pages.filter(p=>p?.page===page);
    catalogAssert(matches.length === 1, 'The wheel catalog has a missing or repeated page.');
    const data = validateFastCatalogPage(matches[0], page, first.collection);
    catalogAssert(data.currency === first.currency && data.totalProducts === first.totalProducts && data.pageSize === first.pageSize, 'The wheel catalog changed while loading. Please try again.');
    for (const initial of data.products) {
      catalogAssert(!seenProducts.has(initial.id), 'A wheel appeared on more than one catalog page. Please try again.'); seenProducts.add(initial.id);
      let raw = initial;
      if (raw.variants.length < raw.variantsCount) {
        const extra = overflowPages.get(raw.id);
        catalogAssert(Array.isArray(extra) && extra.length, 'A wheel has unresolved variant pages.');
        const a = validateFastProductPage(extra.find(p=>p?.page===1), 1, raw, first.currency);
        catalogAssert(extra.length === a.pages, 'Not all wheel option pages were loaded.');
        const completed = [];
        for (let n = 1; n <= a.pages; n++) {
          const one = extra.filter(p=>p?.page===n);
          catalogAssert(one.length === 1, 'A wheel option page was missing or repeated.');
          const checked = validateFastProductPage(one[0], n, raw, first.currency);
          catalogAssert(checked.pageSize === a.pageSize, 'Wheel option page sizes changed.');
          completed.push(...checked.variants);
        }
        catalogVariantIdentity(completed, raw.variantsCount);
        catalogAssert(completed.length === raw.variantsCount, 'A wheel has unresolved variant pages.');
        raw = {...raw, variants:completed, variantsReturned:completed.length};
      }
      for (const v of raw.variants) { catalogAssert(!seenVariants.has(v.id), 'A variant appeared on more than one wheel.'); seenVariants.add(v.id); }
      const out = normalizeFastCatalogProduct(raw, first.currency, origin);
      if (out.product) products.push(out.product);
      variants.push(...out.variants); excluded += out.excluded;
    }
  }
  catalogAssert(seenProducts.size === first.totalProducts, 'The complete wheel catalog was not received.');
  return {variants, products, excluded, productsChecked:seenProducts.size, currency:first.currency};
}
async function catalogPool(items, task, concurrency = 4) {
  let index = 0; const results = new Array(items.length);
  await Promise.all(Array.from({length:Math.min(concurrency, items.length)}, async()=>{
    while (index < items.length) { const n = index++; results[n] = await task(items[n]); }
  }));
  return results;
}
async function loadFastCatalog({signal, baseUrl, onProgress} = {}) {
  const current = typeof location !== 'undefined' ? new URL(location.href) : null;
  const base = new URL(baseUrl || '/collections/all', current?.origin || 'https://www.wheelsoutlet.com');
  catalogAssert(FAST_STORE_ORIGINS.has(base.origin) && /^(?:\/[a-z]{2}(?:-[A-Z]{2})?)?\/collections\/[a-z0-9][a-z0-9-]*\/?$/.test(base.pathname), 'Use the Wheels Outlet collection to load the wheel catalog.');
  const handle = base.pathname.replace(/\/$/,'').split('/').pop();
  const localePrefix = base.pathname.slice(0, base.pathname.indexOf('/collections/'));
  const preview = base.searchParams.get('preview_theme_id') || (current?.origin === base.origin ? current.searchParams.get('preview_theme_id') : null);
  base.search = ''; base.hash = '';
  if (preview && /^\d+$/.test(preview)) base.searchParams.set('preview_theme_id',preview);
  base.searchParams.set('view','wo-fitment-data');
  const controller = new AbortController();
  const abort = ()=>controller.abort(signal?.reason);
  if (signal?.aborted) abort(); else signal?.addEventListener('abort',abort,{once:true});
  let requestCount = 0, loadedPages = 0, totalPages = 1, productsChecked = 0, totalProducts = 0;
  const checkedAt = new Date().toISOString();
  const progress = phase=>{if(typeof onProgress === 'function') onProgress({phase,requestCount,loadedPages,totalPages,productsChecked,totalProducts});};
  const get = async(url)=>{
    if (controller.signal.aborted) throw controller.signal.reason || new DOMException('Aborted','AbortError');
    requestCount++;
    const requestController = new AbortController();
    const cancelRequest = ()=>requestController.abort(controller.signal.reason);
    controller.signal.addEventListener('abort',cancelRequest,{once:true});
    let timedOut = false;
    const timer = setTimeout(()=>{timedOut=true;requestController.abort();},20000);
    try {
      const response = await fetch(url.href,{method:'GET',credentials:'same-origin',cache:'no-store',redirect:'error',signal:requestController.signal,headers:{Accept:'text/html'}});
      if (!response.ok) throw catalogError('The current wheel catalog could not be loaded. Please try again.');
      let data; try { data = await response.json(); } catch {
        if (requestController.signal.aborted) throw requestController.signal.reason || new DOMException('Aborted','AbortError');
        throw catalogError('The fast wheel catalog is not available in this theme yet.');
      }
      return data;
    } catch(error) {
      if (timedOut) throw catalogError('Loading the wheel catalog took too long. Please try again.');
      throw error;
    } finally {
      clearTimeout(timer);
      controller.signal.removeEventListener('abort',cancelRequest);
    }
  };
  const collectionUrl = page=>{const u = new URL(base);u.searchParams.set('page',String(page));return u;};
  try {
    const first = validateFastCatalogPage(await get(collectionUrl(1)),1,handle);
    totalPages=first.pages;totalProducts=first.totalProducts;loadedPages=1;productsChecked=first.products.length;progress('catalog');
    const rest = await catalogPool(Array.from({length:first.pages-1},(_,i)=>i+2),async page=>{
      const p=validateFastCatalogPage(await get(collectionUrl(page)),page,handle);
      loadedPages++;productsChecked+=p.products.length;progress('catalog');return p;
    });
    const pages=[first,...rest],overflow = new Map();
    const incomplete=pages.flatMap(p=>p.products.filter(product=>product.variants.length<product.variantsCount));
    // Rare high-variant products are read independently in complete 50-variant pages.
    // Do not use the truncated initial list as if it were a whole product.
    for (const product of incomplete) {
      const productUrl = page=>{const u = new URL(base);u.pathname=localePrefix+'/products/'+product.handle;u.searchParams.set('page',String(page));return u;};
      const p1=validateFastProductPage(await get(productUrl(1)),1,product,first.currency);progress('variants');
      const remaining=await catalogPool(Array.from({length:p1.pages-1},(_,i)=>i+2),async page=>{
        const p=validateFastProductPage(await get(productUrl(page)),page,product,first.currency);progress('variants');return p;
      });
      overflow.set(product.id,[p1,...remaining]);
    }
    const normalized=normalizeFastCatalogPages(pages,overflow,base.origin);
    return {...normalized,checkedAt,requestCount};
  } catch(error) { controller.abort(); throw error; }
  finally { signal?.removeEventListener('abort',abort); }
}





(function () {
  'use strict';
  var PARAMS = ['year', 'make', 'model', 'trim', 'modification'];
  var KEYS = ['year', 'make', 'model', 'modification'];
  var HIDDEN_MAKES = ['abarth', 'bmwalpina', 'bugatti', 'ferrari', 'panoz', 'morgan', 'mosler'];
  function asUrl(value) {
    try { return new URL(value === undefined ? window.location.href : String(value), window.location.href); }
    catch (_) { return null; }
  }
  function canonical(value) {
    if (!value || typeof value !== 'object') return null;
    var result = {};
    for (var i = 0; i < KEYS.length; i++) {
      var key = KEYS[i], part = value[key];
      if (typeof part !== 'string' && !(key === 'year' && typeof part === 'number')) return null;
      part = String(part);
      if (key === 'year') {
        if (!/^\d{4}$/.test(part) || Number(part) < 1950 || Number(part) > new Date().getFullYear() + 1) return null;
      } else {
        if (!/^[a-z0-9][a-z0-9_-]{0,239}$/i.test(part)) return null;
        part = part.toLowerCase();
      }
      result[key] = part;
    }
    if (HIDDEN_MAKES.includes(result.make.replace(/[^a-z0-9]/g, ''))) return null;
    return result;
  }
  function validTrim(value) {
    return typeof value === 'string' && value.length > 0 && value.length <= 240 && !/[\u0000-\u001f\u007f]/.test(value);
  }
  function has(value) {
    var url = asUrl(value);
    return Boolean(url && PARAMS.some(function (key) { return url.searchParams.has(key); }));
  }
  function read(value) {
    var url = asUrl(value);
    if (!url || PARAMS.some(function (key) { return url.searchParams.getAll(key).length > 1; })) return null;
    if (url.searchParams.has('trim') && !validTrim(url.searchParams.get('trim'))) return null;
    var input = {};
    KEYS.forEach(function (key) { input[key] = url.searchParams.get(key); });
    return canonical(input);
  }
  function withVehicle(detail, value) {
    var url = asUrl(value), vehicle = canonical(detail && detail.vehicle);
    if (!url || !vehicle) return null;
    var trim = detail && detail.labels && detail.labels.modification;
    if (trim !== undefined && !validTrim(trim)) return null;
    PARAMS.forEach(function (key) { url.searchParams.delete(key); });
    KEYS.forEach(function (key) { url.searchParams.set(key, vehicle[key]); });
    if (trim !== undefined) url.searchParams.set('trim', trim);
    return url;
  }
  function commit(url, options) {
    if (!url || url.origin !== window.location.origin) return null;
    try {
      var method = options && options.replace === false ? 'pushState' : 'replaceState';
      window.history[method](window.history.state, '', url.href);
      return url;
    } catch (_) { return null; }
  }
  function write(detail, options) { return commit(withVehicle(detail), options); }
  function clear(options) {
    var url = asUrl();
    if (!url) return null;
    PARAMS.forEach(function (key) { url.searchParams.delete(key); });
    return commit(url, options);
  }
  window.WOVehicleUrl = Object.freeze({ read: read, has: has, withVehicle: withVehicle, write: write, clear: clear });
})();
(function () {
  'use strict';
  var STRINGS = {
    year: 'Year', make: 'Make', model: 'Model', modification: 'Trim',
    select_year: 'Select year', select_make: 'Select make', select_model: 'Select model', select_modification: 'Select trim',
    submit: 'Search wheels', retry: 'Try again',
    ready: 'Select your vehicle to find wheel options.',
    saved: 'Your saved vehicle is selected. You can change any selection.',
    selected: 'Selected trim: {trim}. Search for wheel options.',
    loading_make: 'Loading makes…', loading_model: 'Loading models…', loading_modification: 'Loading trims…',
    choose_make: 'Choose your make.', choose_model: 'Choose your model.', choose_modification: 'Choose your trim.',
    empty_make: 'No makes were found for this year. Choose another year.',
    empty_model: 'No models were found for this selection. Choose another make.',
    empty_modification: 'No trims were found for this selection. Choose another model.',
    retry_seconds: 'Please wait {seconds} seconds before trying again.',
    rate_limited: 'Please wait a moment before trying again.',
    unavailable: 'Vehicle search is temporarily unavailable. Please try again later.',
    unreadable: 'The vehicle list could not be read. Please try again.',
    failed: 'The vehicle list could not be loaded. Please try again.',
    connection: 'We could not connect. Check your connection and try again.',
    timeout: 'The request took too long. Please try again.',
    incomplete: 'Complete the vehicle selection before searching.'
  };
  var SELECTED_KEY = 'wo-fitment:selected-vehicle:v1';
  var LISTS_KEY = 'wo-fitment:vehicle-lists:v2';
  var ENDPOINT = 'https://wheelsoutlet-fitment.rock-4d1.workers.dev/storefront-api';
  var KEYS = ['year', 'make', 'model', 'modification'];
  var STEPS = { make: 'makes', model: 'models', modification: 'modifications' };

  function hiddenMake(value, label) {
    return [value, label].some(function (part) {
      var name = String(part ?? '').normalize('NFKC').toLowerCase().replace(/[^a-z0-9]/g, '');
      return ['abarth', 'bmwalpina', 'bugatti', 'ferrari', 'panoz', 'morgan', 'mosler'].includes(name);
    });
  }
  function node(tag, className, text) {
    var result = document.createElement(tag);
    if (className) result.className = 'wo-vehicle-picker__' + className;
    if (text !== undefined) result.textContent = String(text);
    return result;
  }
  function initialize(root) {
    if (root.dataset.woVehiclePickerInitialized === 'true') return;
    root.dataset.woVehiclePickerInitialized = 'true';
    root.classList.add('wo-vehicle-picker');
    var overrides = {};
    try {
      var localeNode = root.querySelector('script[type="application/json"][data-wo-vehicle-picker-i18n]');
      if (localeNode) overrides = JSON.parse(localeNode.textContent) || {};
    } catch (_) {}
    function t(key, values) {
      var text = typeof overrides[key] === 'string' ? overrides[key] : STRINGS[key] || key;
      return text.replace(/\{([a-zA-Z0-9_]+)\}/g, function (token, name) { return values && values[name] !== undefined ? String(values[name]) : token; });
    }
    var endpoint;
    try {
      endpoint = new URL(root.dataset.endpoint || ENDPOINT);
      if (endpoint.protocol !== 'https:') throw new Error('Invalid endpoint');
    } catch (_) { root.replaceChildren(node('p', 'error', t('unavailable'))); return; }
    var state = { sequence: 0, interactionVersion: 0, pending: null, retry: null, loadedFor: {}, cache: {}, urlVehicle: null };
    var ui = { fields: {} };
    try {
      var savedCache = JSON.parse(sessionStorage.getItem(LISTS_KEY) || '{}');
      if (savedCache && typeof savedCache === 'object' && !Array.isArray(savedCache)) state.cache = savedCache;
    } catch (_) {}
    ui.form = node('form', 'form');
    KEYS.forEach(function (key) {
      var label = node('label', 'field');
      var select = node('select', 'select');
      select.name = key;
      select.setAttribute('aria-label', t(key));
      select.dataset.woField = key;
      label.append(node('span', 'label', t(key)), select);
      ui.form.append(label);
      ui.fields[key] = select;
    });
    ui.submit = node('button', 'submit', t('submit'));
    ui.submit.type = 'submit';
    var action = node('div', 'action'); action.append(ui.submit); ui.form.append(action);
    ui.status = node('p', 'status', t('ready'));
    ui.status.setAttribute('role', 'status');
    ui.status.setAttribute('aria-live', 'polite');
    ui.status.setAttribute('aria-atomic', 'true');
    ui.error = node('div', 'error');
    ui.error.hidden = true;
    ui.error.setAttribute('role', 'alert');
    ui.errorText = node('p');
    ui.retry = node('button', 'retry', t('retry'));
    ui.retry.type = 'button';
    ui.error.append(ui.errorText, ui.retry);
    root.replaceChildren(ui.form, ui.status, ui.error);

    function selected() {
      var result = {};
      KEYS.forEach(function (key) { result[key] = ui.fields[key].value; });
      return result;
    }
    function selectedLabels() {
      var result = {};
      KEYS.forEach(function (key) { result[key] = ui.fields[key].selectedOptions[0]?.textContent || ''; });
      return result;
    }
    function currentMakeHidden() { return hiddenMake(ui.fields.make.value, ui.fields.make.selectedOptions[0]?.textContent); }
    function complete() {
      return !currentMakeHidden() && KEYS.every(function (key) { return Boolean(ui.fields[key].value) && (!state.urlVehicle || ui.fields[key].value === state.urlVehicle[key]); }) &&
        KEYS.slice(1).every(function (key) { return state.loadedFor[key] === cacheKey(key); });
    }
    function selectedStatus() { return t('selected', { trim: selectedLabels().modification }); }
    function parentsPresent(key) { return KEYS.slice(0, KEYS.indexOf(key)).every(function (parent) { return Boolean(ui.fields[parent].value); }); }
    function cacheKey(key) {
      return JSON.stringify([key].concat(KEYS.slice(0, KEYS.indexOf(key)).map(function (parent) { return ui.fields[parent].value; })));
    }
    function sync() {
      KEYS.forEach(function (key) {
        ui.fields[key].disabled = key !== 'year' && (!parentsPresent(key) || ui.fields[key].options.length < 2);
      });
      ui.submit.disabled = Boolean(state.pending) || !complete();
      ui.retry.disabled = Boolean(state.pending);
      ui.form.setAttribute('aria-busy', String(Boolean(state.pending)));
    }
    function reset(key) {
      var option = node('option', '', t('select_' + key)); option.value = '';
      ui.fields[key].replaceChildren(option);
      delete state.loadedFor[key];
    }
    function clearAfter(key) { KEYS.slice(KEYS.indexOf(key) + 1).forEach(reset); }
    function clearSaved() { try { sessionStorage.removeItem(SELECTED_KEY); } catch (_) {} }
    function saveSelected() {
      // Shared URLs must resolve to real list labels before becoming a saved selection.
      if (state.urlVehicle && !complete()) { clearSaved(); return; }
      // Keep ordinary saved labels and slugs during list validation.
      if (currentMakeHidden() || !KEYS.every(function (key) { return Boolean(ui.fields[key].value); })) { clearSaved(); return; }
      var values = selected(), labels = selectedLabels(), data = {};
      KEYS.forEach(function (key) { data[key] = { value: values[key], label: labels[key] }; });
      try { sessionStorage.setItem(SELECTED_KEY, JSON.stringify(data)); } catch (_) {}
    }
    function normalize(choices, preserveOrder, filterMakes) {
      var seen = new Set(), result = [];
      (Array.isArray(choices) ? choices : []).forEach(function (item) {
        var isObject = item && typeof item === 'object';
        var value = isObject ? item.value ?? item.slug ?? item.id ?? item.name : item;
        var label = isObject ? item.label ?? item.name ?? item.title ?? value : item;
        if (value === null || value === undefined || String(value) === '' || seen.has(String(value))) return;
        if (filterMakes && hiddenMake(value, label)) return;
        seen.add(String(value));
        result.push({ value: String(value), label: String(label) });
      });
      if (!preserveOrder) result.sort(function (a, b) { return a.label.localeCompare(b.label, undefined, { numeric: true, sensitivity: 'base' }); });
      return result;
    }
    function cached(key) {
      var items = state.cache[cacheKey(key)];
      if (!Array.isArray(items) || !items.every(function (item) { return item && typeof item.value === 'string' && typeof item.label === 'string'; })) return null;
      return normalize(items, key === 'modification', key === 'make');
    }
    function remember(key, choices) {
      var id = cacheKey(key);
      delete state.cache[id]; state.cache[id] = choices;
      var entries = Object.keys(state.cache);
      while (entries.length > 24) delete state.cache[entries.shift()];
      try { sessionStorage.setItem(LISTS_KEY, JSON.stringify(state.cache)); } catch (_) {}
    }
    function fill(key, choices, value) {
      reset(key);
      choices.forEach(function (choice) { var option = node('option', '', choice.label); option.value = choice.value; ui.fields[key].append(option); });
      if (value && choices.some(function (choice) { return choice.value === value; })) ui.fields[key].value = value;
      else if (key === 'modification' && choices.length && !state.urlVehicle) ui.fields[key].value = choices[0].value;
      state.loadedFor[key] = cacheKey(key);
    }
    function fillYears() {
      reset('year');
      var last = new Date().getFullYear() + 1;
      for (var year = last; year >= 1950; year--) { var option = node('option', '', year); option.value = String(year); ui.fields.year.append(option); }
    }
    function restore() {
      try {
        var data;
        var urlHelper = window.WOVehicleUrl;
        var hasVehicleUrl = urlHelper ? urlHelper.has() : ['year', 'make', 'model', 'trim', 'modification'].some(function (key) { return new URLSearchParams(window.location.search).has(key); });
        if (hasVehicleUrl) {
          // Even an invalid or partial link takes precedence over an unrelated saved vehicle.
          clearSaved();
          state.urlVehicle = urlHelper ? urlHelper.read() : null;
          if (!state.urlVehicle) { ui.status.textContent = t('incomplete'); return; }
          data = {};
          KEYS.forEach(function (key) { data[key] = { value: state.urlVehicle[key], label: state.urlVehicle[key] }; });
        } else data = JSON.parse(sessionStorage.getItem(SELECTED_KEY) || 'null');
        if (hiddenMake(data?.make?.value, data?.make?.label)) { clearSaved(); return; }
        if (!data || !KEYS.every(function (key) { return typeof data[key]?.value === 'string' && data[key].value.length > 0 && data[key].value.length <= 240 && typeof data[key]?.label === 'string' && data[key].label.length <= 240; })) return;
        if (!Array.from(ui.fields.year.options).some(function (option) { return option.value === data.year.value; })) return;
        ui.fields.year.value = data.year.value;
        KEYS.slice(1).forEach(function (key) {
          if (!parentsPresent(key)) return;
          var choices = cached(key);
          if (choices) fill(key, choices, data[key].value);
          else {
            var option = node('option', '', data[key].label);
            option.value = data[key].value;
            ui.fields[key].append(option); ui.fields[key].value = data[key].value;
          }
        });
        // Saved selections remain unverified until their current parent lists are loaded.
        if (complete()) ui.status.textContent = selectedStatus();
        else if (state.urlVehicle) ui.status.textContent = t('incomplete');
        saveSelected();
      } catch (_) {}
    }
    function stopPending() {
      state.sequence++;
      if (state.pending) state.pending.controller.abort();
      state.pending = null;
      state.retry = null;
      ui.error.hidden = true;
    }
    async function request(step, signal) {
      var controller = new AbortController(), timedOut = false;
      function abort() { controller.abort(); }
      if (signal.aborted) throw new DOMException('Cancelled', 'AbortError');
      signal.addEventListener('abort', abort, { once: true });
      var timer = setTimeout(function () { timedOut = true; controller.abort(); }, 30000);
      try {
        var response = await fetch(endpoint.href, {
          method: 'POST', mode: 'cors', credentials: 'omit', cache: 'no-store',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(Object.assign({ step: step }, selected())), signal: controller.signal
        });
        if (response.status === 401 || response.status === 403) throw new Error(t('unavailable'));
        if (response.status === 429) {
          var seconds = Number(response.headers.get('Retry-After'));
          throw new Error(Number.isFinite(seconds) && seconds > 0 && seconds <= 3600 ? t('retry_seconds', { seconds: Math.ceil(seconds) }) : t('rate_limited'));
        }
        var data;
        try { data = await response.json(); } catch (_) { throw new Error(t('unreadable')); }
        if (!response.ok || !data || data.error) {
          var message = typeof data?.error === 'string' ? data.error : data?.error?.message;
          throw new Error(message || t('failed'));
        }
        if (!Array.isArray(data.choices)) throw new Error(t('unreadable'));
        return normalize(data.choices, step === 'modifications', step === 'makes');
      } catch (error) {
        if (timedOut) throw new Error(t('timeout'));
        if (error instanceof TypeError) throw new Error(t('connection'));
        throw error;
      } finally { clearTimeout(timer); signal.removeEventListener('abort', abort); }
    }
    async function load(key, preserve) {
      if (!parentsPresent(key)) return;
      var id = cacheKey(key), value = preserve ? ui.fields[key].value : '';
      if (state.loadedFor[key] === id) return;
      if (state.pending?.key === key && state.pending.id === id) return;
      stopPending();
      if (key === 'modification' && !preserve) { reset(key); clearSaved(); }
      var sequence = state.sequence;
      var choices = cached(key);
      if (choices) {
        fill(key, choices, value);
        if (value && !ui.fields[key].value) { clearAfter(key); clearSaved(); }
        ui.status.textContent = complete() ? selectedStatus() : t(choices.length ? 'choose_' + key : 'empty_' + key);
        saveSelected(); sync(); return;
      }
      var controller = new AbortController();
      state.pending = { key: key, id: id, controller: controller };
      ui.status.textContent = t('loading_' + key); sync();
      try {
        choices = await request(STEPS[key], controller.signal);
        if (controller.signal.aborted || sequence !== state.sequence || id !== cacheKey(key)) return;
        remember(key, choices);
        fill(key, choices, value);
        if (value && !ui.fields[key].value) { clearAfter(key); clearSaved(); }
        ui.status.textContent = complete() ? selectedStatus() : t(choices.length ? 'choose_' + key : 'empty_' + key);
        saveSelected();
      } catch (error) {
        if (sequence !== state.sequence || error.name === 'AbortError') return;
        ui.errorText.textContent = error.message || t('failed'); ui.error.hidden = false;
        ui.status.textContent = t('failed'); state.retry = async function () {
          var version = state.interactionVersion;
          await load(key, preserve);
          if (preserve && version === state.interactionVersion && state.loadedFor[key] === cacheKey(key)) hydrateSavedLists();
        };
      } finally {
        if (sequence === state.sequence) { state.pending = null; sync(); }
      }
    }
    async function hydrateSavedLists() {
      // Catalog lists are cacheable; this never performs a vehicle fitment Search.
      var version = state.interactionVersion;
      for (var i = 1; i < KEYS.length; i++) {
        var key = KEYS[i];
        if (version !== state.interactionVersion || !parentsPresent(key)) return;
        if (state.loadedFor[key] === cacheKey(key)) continue;
        await load(key, true);
        if (version !== state.interactionVersion || state.loadedFor[key] !== cacheKey(key)) return;
      }
    }
    function changed(key) {
      state.urlVehicle = null;
      state.interactionVersion++;
      stopPending(); clearAfter(key); clearSaved(); sync();
      if (!ui.fields[key].value) { ui.status.textContent = t('ready'); return; }
      var index = KEYS.indexOf(key);
      if (index === KEYS.length - 1) {
        saveSelected(); ui.status.textContent = selectedStatus(); sync();
        if (!complete()) hydrateSavedLists();
        return;
      }
      load(KEYS[index + 1], false);
    }
    KEYS.forEach(function (key) {
      ui.fields[key].addEventListener('change', function () { changed(key); });
      if (key !== 'year') {
        function ensureChoices() { if (!state.pending && parentsPresent(key) && state.loadedFor[key] !== cacheKey(key)) load(key, true); }
        ui.fields[key].addEventListener('focus', ensureChoices);
        ui.fields[key].addEventListener('pointerdown', ensureChoices);
      }
    });
    ui.form.addEventListener('submit', function (event) {
      event.preventDefault();
      if (state.pending || !complete()) { ui.status.textContent = t('incomplete'); return; }
      saveSelected();
      var labels = selectedLabels();
      root.dispatchEvent(new CustomEvent('wo:vehicle-submit', {
        bubbles: true, composed: true, cancelable: true,
        detail: { vehicle: selected(), label: KEYS.map(function (key) { return labels[key]; }).join(' '), labels: labels }
      }));
    });
    ui.retry.addEventListener('click', function () { if (!state.pending && state.retry) state.retry(); });
    KEYS.forEach(reset); fillYears(); restore(); sync();
    if (ui.fields.year.value && ui.fields.make.value) hydrateSavedLists();
  }
  function initializeWithin(root) {
    if (root.matches?.('[data-wo-vehicle-picker]')) initialize(root);
    root.querySelectorAll('[data-wo-vehicle-picker]').forEach(initialize);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initializeWithin(document); }, { once: true });
  else initializeWithin(document);
  document.addEventListener('shopify:section:load', function (event) { initializeWithin(event.target); });
})();
(function () {
  'use strict';
  if (window.__woVehicleResultsInstalled) return;
  window.__woVehicleResultsInstalled = true;
  var STRINGS = {
    title: 'Wheels for your vehicle', ready: 'Choose your vehicle and search to see suggested wheels.',
    notice: 'Suggested fitment only. Center bore is not compared; brake clearance and load rating need confirmation before ordering. Availability is per wheel, not a confirmed set of four.',
    checking: 'Checking your vehicle and wheel availability…', checking_catalog: 'Checking wheel availability…',
    complete: 'Availability checked {date}.', cancelled: 'Search cancelled. Search again when you are ready.',
    changed: 'Vehicle changed. Search to update your wheel suggestions.',
    retry: 'Try again', cancel: 'Cancel', refresh: 'Refresh availability',
    error: 'The search could not finish. Please try again.', timeout: 'The vehicle request took too long. Please try again.',
    unavailable: 'Vehicle search is temporarily unavailable. Please try again later.',
    connection: 'We could not connect. Check your connection and try again.',
    rate_limited: 'Please wait a moment before trying again.', retry_seconds: 'Please wait {seconds} seconds before trying again.',
    invalid_vehicle: 'Choose a complete vehicle selection before searching.',
    exact_vehicle: 'Choose an exact supported vehicle trim to see wheel suggestions.',
    unsupported_vehicle: 'No supported wheel reference was found for this trim. Choose another vehicle.',
    catalog_error: 'Current wheel availability could not be confirmed. Please try again.',
    comparison_error: 'The wheel comparison is temporarily unavailable. Please try again later.',
    expired: 'Choose Search wheels to check this vehicle. Your previous search has expired.',
    storage_error: 'Your browser could not save the vehicle selection. Please enable session storage and try again.',
    filters: 'Filters', brand: 'Brand', diameter: 'Diameter', finish: 'Finish', clear_filters: 'Clear filters',
    all_diameters: 'All diameters', selected_diameters: '{count} selected',
    sort: 'Sort by', featured: 'Featured', price_low: 'Price: low to high', price_high: 'Price: high to low', diameter_sort: 'Diameter',
    products_one: '{count} wheel', products_other: '{count} wheels',
    vehicle_heading: 'Suggested wheels for {vehicle}',
    no_results: 'No suggested wheels were found for this vehicle. Try another selection or contact us for fitment help.',
    no_filter_results: 'No wheels match these filters. Try another brand, diameter or finish.',
    price_filtered: 'Some prices could not be confirmed in {currency} and are not shown.',
    price_unit: '{currency} per wheel', available: 'Available to order', backorder: 'Available to backorder',
    image_unavailable: 'Image unavailable', finish_unknown: 'Finish unavailable', other_brand: 'Other',
    show_finish: 'Show {finish}', wheel: 'Wheel', wheel_image: '{title} — {finish}',
    size: '{diameter} × {width} in · ET {offset}', diameter_value: '{diameter} inch',
    plus_size: 'Plus size — check tire size',
    previous: 'Previous', next: 'Next', page: 'Page {page} of {pages}', pagination: 'Wheel results pages',
    just_checked: 'just checked', view_wheel: 'View {title}, {finish}, {size}'
  };
  var INTENT_KEY = 'wo-fitment:search-intent:v2';
  var INTENT_TTL = 60000, CACHE_TTL = 300000, PAGE_SIZE = 25;
  var ENDPOINT = 'https://wheelsoutlet-fitment.rock-4d1.workers.dev/storefront-api';
  var KEYS = ['year', 'make', 'model', 'modification'];
  var activeController = null;
  function el(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text !== undefined) node.textContent = String(text);
    return node;
  }
  function blockedMake(value) {
    return typeof value === 'string' && ['abarth', 'bmwalpina', 'bugatti', 'ferrari', 'panoz', 'morgan', 'mosler'].includes(value.normalize('NFKC').toLowerCase().replace(/[^a-z0-9]/g, ''));
  }
  function validDetail(detail) {
    if (!detail || !detail.vehicle || !KEYS.every(function (key) { return typeof detail.vehicle[key] === 'string' && detail.vehicle[key].length > 0 && detail.vehicle[key].length <= 240; })) return null;
    if (blockedMake(detail.vehicle.make) || blockedMake(detail.labels?.make)) return null;
    var vehicle = {}, labels = {};
    KEYS.forEach(function (key) { vehicle[key] = detail.vehicle[key]; labels[key] = typeof detail.labels?.[key] === 'string' ? detail.labels[key].slice(0, 240) : vehicle[key]; });
    return { vehicle: vehicle, labels: labels, label: typeof detail.label === 'string' && detail.label.trim() ? detail.label.slice(0, 1000) : KEYS.map(function (key) { return labels[key]; }).join(' ') };
  }
  function initialize(root) {
    if (root.dataset.woVehicleResultsInitialized === 'true') return;
    root.dataset.woVehicleResultsInitialized = 'true';
    root.classList.add('wo-vehicle-results');
    root.dataset.woResultsState = 'idle';
    var overrides = {};
    try { var dictionary = root.querySelector('script[type="application/json"][data-wo-vehicle-results-i18n]'); if (dictionary) overrides = JSON.parse(dictionary.textContent) || {}; } catch (_) {}
    function t(key, values) {
      var text = typeof overrides[key] === 'string' ? overrides[key] : STRINGS[key] || key;
      return text.replace(/\{([a-zA-Z0-9_]+)\}/g, function (token, name) { return values && values[name] !== undefined ? String(values[name]) : token; });
    }
    var locale = root.lang || document.documentElement.lang || navigator.language || 'en';
    var currency = /^[A-Z]{3}$/.test(root.dataset.currency || '') ? root.dataset.currency : 'USD';
    var endpoint;
    try { endpoint = new URL(root.dataset.endpoint || ENDPOINT); if (endpoint.protocol !== 'https:') throw new Error(); }
    catch (_) { root.replaceChildren(el('p', 'wo-vehicle-error', t('unavailable'))); return; }
    var s = { sequence: 0, controller: null, busy: false, last: null, lastForce: false, vehicleRef: null, refKey: null, matches: [], groups: [], page: 1, memo: null, checkedAt: null, sort: 'featured', filters: { brand: new Set(), diameter: new Set(), finish: new Set() }, priceRejected: 0 };
    var ui = {};
    var header = el('div', 'wo-vehicle-results-heading');
    ui.title = el('h2', '', t('title')); ui.title.hidden = true;
    ui.vehicle = el('p', 'wo-vehicle-summary');
    header.append(ui.title, ui.vehicle);
    var notice = el('p', 'wo-vehicle-notice', t('notice'));
    var workline = el('div', 'wo-vehicle-workline');
    ui.status = el('p', 'wo-vehicle-status', t('ready'));
    ui.status.setAttribute('role', 'status'); ui.status.setAttribute('aria-live', 'polite'); ui.status.setAttribute('aria-atomic', 'true');
    ui.progress = el('progress', 'wo-vehicle-progress'); ui.progress.hidden = true; ui.progress.setAttribute('aria-label', t('checking_catalog'));
    ui.cancel = makeButton(t('cancel')); ui.cancel.hidden = true;
    workline.append(ui.status, ui.progress, ui.cancel);
    ui.error = el('div', 'wo-vehicle-error'); ui.error.hidden = true; ui.error.setAttribute('role', 'alert');
    ui.errorText = el('p'); ui.retry = makeButton(t('retry')); ui.error.append(ui.errorText, ui.retry);
    ui.layout = el('div', 'wo-catalog-layout'); ui.layout.hidden = true;
    ui.mobileDiameter = el('label', 'wo-vehicle-mobile-diameter');
    ui.mobileDiameter.append(el('span', '', t('diameter')));
    ui.mobileDiameterSelect = el('select'); ui.mobileDiameterSelect.setAttribute('aria-label', t('diameter'));
    ui.mobileDiameter.append(ui.mobileDiameterSelect);
    ui.filterPanel = el('details', 'wo-filters wo-vehicle-filter-panel');
    var mobileViewport = window.matchMedia('(max-width: 799px)');
    ui.filterPanel.open = !mobileViewport.matches;
    ui.filterPanel.append(el('summary', 'wo-filters__summary', t('filters')));
    ui.filterBody = el('div', 'wo-filters__body');
    ui.clear = makeButton(t('clear_filters')); ui.clear.classList.add('wo-vehicle-clear');
    ui.filterPanel.append(ui.filterBody, ui.clear);
    var main = el('div', 'wo-vehicle-main');
    var toolbar = el('div', 'wo-results-toolbar wo-vehicle-toolbar');
    ui.count = el('p', 'wo-vehicle-count');
    var sortLabel = el('label', 'wo-vehicle-sort');
    sortLabel.append(el('span', '', t('sort')));
    ui.sort = el('select'); ui.sort.setAttribute('aria-label', t('sort'));
    [['featured', 'featured'], ['price-low', 'price_low'], ['price-high', 'price_high'], ['diameter', 'diameter_sort']].forEach(function (item) { var option = el('option', '', t(item[1])); option.value = item[0]; ui.sort.append(option); });
    sortLabel.append(ui.sort); ui.refresh = makeButton(t('refresh')); ui.refresh.classList.add('wo-vehicle-refresh');
    toolbar.append(ui.count, sortLabel, ui.refresh);
    ui.priceNote = el('p', 'wo-vehicle-price-note'); ui.priceNote.hidden = true;
    ui.empty = el('div', 'wo-no-results wo-vehicle-empty'); ui.empty.hidden = true;
    ui.grid = el('div', 'wo-results-grid');
    ui.pager = el('nav', 'wo-pagination wo-vehicle-pagination'); ui.pager.setAttribute('aria-label', t('pagination'));
    ui.previous = makeButton(t('previous')); ui.next = makeButton(t('next')); ui.page = el('span');
    ui.pager.append(ui.previous, ui.page, ui.next);
    main.append(toolbar, ui.priceNote, ui.empty, ui.grid, ui.pager); ui.layout.append(ui.mobileDiameter, ui.filterPanel, main);
    root.replaceChildren(header, notice, workline, ui.error, ui.layout);
    function makeButton(text) { var node = el('button', 'wo-vehicle-button', text); node.type = 'button'; return node; }
    function status(text) { if (ui.status.textContent !== text) ui.status.textContent = text; }
    function checked(value) { var date = new Date(value); return Number.isFinite(date.getTime()) ? date.toLocaleString(locale, { month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' }) : t('just_checked'); }
    function clearResults(message) {
      root.dataset.woResultsState = 'idle';
      s.sequence++; s.controller?.abort(); s.controller = null; s.busy = false; s.last = null; s.vehicleRef = null; s.refKey = null;
      s.matches = []; s.groups = []; s.page = 1; s.checkedAt = null;
      ui.grid.replaceChildren(); ui.layout.hidden = true; ui.error.hidden = true; ui.progress.hidden = true; ui.cancel.hidden = true;
      ui.title.textContent = t('title'); ui.title.hidden = true; ui.vehicle.textContent = ''; status(message || t('ready'));
      root.setAttribute('aria-busy', 'false');
    }
    async function fitment(detail, signal) {
      var controller = new AbortController(), timedOut = false;
      function abort() { controller.abort(); }
      if (signal.aborted) throw new DOMException('Cancelled', 'AbortError');
      signal.addEventListener('abort', abort, { once: true });
      var timer = setTimeout(function () { timedOut = true; controller.abort(); }, 30000);
      try {
        var response = await fetch(endpoint.href, { method: 'POST', mode: 'cors', credentials: 'omit', cache: 'no-store', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(Object.assign({ step: 'fitment' }, detail.vehicle)), signal: controller.signal });
        if (response.status === 401 || response.status === 403) throw new Error(t('unavailable'));
        if (response.status === 429) { var seconds = Number(response.headers.get('Retry-After')); throw new Error(Number.isFinite(seconds) && seconds > 0 && seconds <= 3600 ? t('retry_seconds', { seconds: Math.ceil(seconds) }) : t('rate_limited')); }
        var data; try { data = await response.json(); } catch (_) { throw new Error(t('error')); }
        if (!response.ok || !data || data.error) throw new Error((typeof data?.error === 'string' ? data.error : data?.error?.message) || t('error'));
        if (!Array.isArray(data.records) || data.records.length !== 1) throw new Error(t('exact_vehicle'));
        var vehicle = data.records[0];
        if (!vehicle || !Array.isArray(vehicle.wheels) || !vehicle.wheels.length) throw new Error(t('unsupported_vehicle'));
        return vehicle;
      } catch (error) {
        if (timedOut) throw new Error(t('timeout'));
        if (error instanceof TypeError) throw new Error(t('connection'));
        throw error;
      } finally { clearTimeout(timer); signal.removeEventListener('abort', abort); }
    }
    async function catalog(signal, sequence, force) {
      if (!force && s.memo && Date.now() - s.memo.freshnessAt < CACHE_TTL) return s.memo.data;
      if (typeof loadFastCatalog !== 'function') throw new Error(t('catalog_error'));
      var startedAt = Date.now();
      var data = await loadFastCatalog({ signal: signal, onProgress: function () { if (sequence === s.sequence && !signal.aborted) status(t('checking_catalog')); } });
      if (signal.aborted) throw new DOMException('Cancelled', 'AbortError');
      if (!data || !Array.isArray(data.variants)) throw new Error(t('catalog_error'));
      var time = Date.parse(data.checkedAt);
      s.memo = { data: data, freshnessAt: Math.min(startedAt, Number.isFinite(time) ? time : startedAt) };
      return data;
    }
    function validMoney(variant) {
      return String(variant.currency || '').toUpperCase() === currency && (typeof variant.price === 'string' || typeof variant.price === 'number') && String(variant.price).trim() !== '' && Number.isFinite(Number(variant.price)) && Number(variant.price) >= 0;
    }
    async function search(raw, force) {
      var detail = validDetail(raw);
      if (!detail) { root.dataset.woResultsState = 'error'; ui.errorText.textContent = t('invalid_vehicle'); ui.error.hidden = false; return; }
      root.dataset.woResultsState = 'loading';
      s.sequence++; var sequence = s.sequence; s.controller?.abort();
      var controller = new AbortController(); s.controller = controller; s.busy = true; s.last = detail; s.lastForce = Boolean(force);
      s.matches = []; s.groups = []; s.page = 1; s.filters = { brand: new Set(), diameter: new Set(), finish: new Set() }; s.sort = 'featured'; ui.sort.value = 'featured';
      ui.grid.replaceChildren(); ui.layout.hidden = true; ui.error.hidden = true; ui.progress.hidden = false; ui.cancel.hidden = false;
      ui.title.textContent = t('vehicle_heading', { vehicle: detail.label }); ui.title.hidden = false; ui.vehicle.textContent = ''; status(t('checking')); root.setAttribute('aria-busy', 'true');
      try {
        var refKey = JSON.stringify(detail.vehicle);
        var reference = force && s.vehicleRef && s.refKey === refKey ? Promise.resolve(s.vehicleRef) : fitment(detail, controller.signal).then(function (vehicle) {
          if (sequence === s.sequence && !controller.signal.aborted) { s.vehicleRef = vehicle; s.refKey = refKey; }
          return vehicle;
        });
        var data = await Promise.all([reference, catalog(controller.signal, sequence, force)]);
        if (sequence !== s.sequence || controller.signal.aborted) return;
        if (typeof matchPlusSizeWheelCandidates !== 'function') throw new Error(t('comparison_error'));
        var matches = matchPlusSizeWheelCandidates(data[0], data[1].variants, { maxDiameterIncrease: 2 });
        if (!Array.isArray(matches)) throw new Error(t('comparison_error'));
        var unique = new Map(); s.priceRejected = 0;
        matches.forEach(function (match) {
          var variant = match.variant;
          if (!variant || !(variant.available === true || variant.backorder === true)) return;
          if (!validMoney(variant)) { s.priceRejected++; return; }
          if (!productUrl(variant)) return;
          unique.set(String(variant.id), match);
        });
        s.matches = Array.from(unique.values()); s.checkedAt = data[1].checkedAt || new Date().toISOString();
        buildFilters(); render();
        ui.title.textContent = t('vehicle_heading', { vehicle: detail.label }); ui.vehicle.textContent = '';
        status(t('complete', { date: checked(s.checkedAt) }));
        root.dataset.woResultsState = 'success';
      } catch (error) {
        if (sequence !== s.sequence) return;
        root.dataset.woResultsState = 'error';
        controller.abort();
        ui.errorText.textContent = error.name === 'AbortError' ? t('cancelled') : error.message || t('error');
        ui.error.hidden = false; status(error.name === 'AbortError' ? t('cancelled') : t('error'));
      } finally {
        if (sequence === s.sequence) { s.busy = false; s.controller = null; ui.progress.hidden = true; ui.cancel.hidden = true; root.setAttribute('aria-busy', 'false'); }
      }
    }
    function brand(match) { return String(match.variant.product?.vendor || t('other_brand')); }
    function finish(match) { return String(match.variant.finish || '').trim(); }
    function productId(match) { return String(match.variant.product?.id || match.variant.product?.handle || ''); }
    function variantSort(a, b) { return Number(a.specification.diameter) - Number(b.specification.diameter) || Number(a.specification.width) - Number(b.specification.width) || Number(a.specification.offset) - Number(b.specification.offset) || String(a.variant.id).localeCompare(String(b.variant.id)); }
    function rank(group) { var name = brand(group.variants[0]).toLowerCase(); return name.includes('vors') ? 0 : name.includes('mrr') ? 1 : 2; }
    function buildFilters() {
      ui.filterBody.replaceChildren();
      [['diameter', function (match) { return String(match.specification.diameter); }], ['finish', finish], ['brand', brand]].forEach(function (pair) {
        var key = pair[0], values = key === 'finish'
          ? finishFilterOptions(s.matches.map(finish))
          : Array.from(new Set(s.matches.map(pair[1]).filter(Boolean)));
        values.sort(key === 'diameter' ? function (a, b) { return Number(a) - Number(b); } : function (a, b) { return a.localeCompare(b); });
        if (key === 'diameter') {
          var all = el('option', '', t('all_diameters')); all.value = '';
          ui.mobileDiameterMultiple = el('option'); ui.mobileDiameterMultiple.value = '__multiple'; ui.mobileDiameterMultiple.disabled = true;
          ui.mobileDiameterSelect.replaceChildren(all, ui.mobileDiameterMultiple);
          values.forEach(function (value) { var option = el('option', '', t('diameter_value', { diameter: value })); option.value = value; ui.mobileDiameterSelect.append(option); });
          ui.mobileDiameter.hidden = values.length === 0;
        }
        var group = el('details', 'wo-filter-group'); group.open = true; group.dataset.woFilterGroup = key;
        group.append(el('summary', '', t(key))); var list = el('div', 'wo-filter-values');
        values.forEach(function (value) {
          var label = el('label', 'wo-native-choice'), input = el('input'); input.type = 'checkbox'; input.value = value; input.dataset.woFilter = key;
          input.setAttribute('aria-label', key === 'diameter' ? t('diameter_value', { diameter: value }) : value);
          label.append(input, el('span', '', key === 'diameter' ? t('diameter_value', { diameter: value }) : value)); list.append(label);
          input.addEventListener('change', function () { if (input.checked) s.filters[key].add(value); else s.filters[key].delete(value); s.page = 1; render(); });
        });
        group.append(list); ui.filterBody.append(group);
      });
    }
    function groups() {
      var map = new Map();
      s.matches.forEach(function (match) {
        if (s.filters.brand.size && !s.filters.brand.has(brand(match))) return;
        if (s.filters.diameter.size && !s.filters.diameter.has(String(match.specification.diameter))) return;
        if (!finishMatchesFilter(finish(match), s.filters.finish)) return;
        var id = productId(match); if (!id) return;
        if (!map.has(id)) map.set(id, { id: id, variants: [] });
        map.get(id).variants.push(match);
      });
      var result = Array.from(map.values());
      result.forEach(function (group) { group.variants.sort(variantSort); group.title = String(group.variants[0].variant.product?.title || t('wheel')); group.price = Number(group.variants[0].variant.price); group.diameter = Number(group.variants[0].specification.diameter); });
      result.sort(function (a, b) {
        if (s.sort === 'price-low' && a.price !== b.price) return a.price - b.price;
        if (s.sort === 'price-high' && a.price !== b.price) return b.price - a.price;
        if (s.sort === 'diameter' && a.diameter !== b.diameter) return a.diameter - b.diameter;
        return (s.sort === 'featured' ? rank(a) - rank(b) : 0) || a.title.localeCompare(b.title) || a.id.localeCompare(b.id);
      });
      return result;
    }
    function productUrl(variant) {
      var raw = variant.productUrl || variant.product?.onlineStoreUrl; if (!raw) return null;
      try {
        var url = new URL(raw), handle = String(variant.product?.handle || ''), id = String(variant.id).split('/').pop();
        if (url.protocol !== 'https:' || !['www.wheelsoutlet.com', 'wheelsoutlet.com'].includes(url.hostname.toLowerCase()) || url.username || url.password) return null;
        if (!/^[a-z0-9]+(?:-[a-z0-9]+)*$/i.test(handle) || url.pathname.replace(/\/$/, '') !== '/products/' + handle || !/^\d+$/.test(id)) return null;
        url.searchParams.set('variant', id); return url.href;
      } catch (_) { return null; }
    }
    function imageSource(image) {
      var raw = typeof image === 'string' ? image : image?.src || image?.url;
      if (!raw) return null;
      try { var url = new URL(raw, 'https://www.wheelsoutlet.com'); return url.protocol === 'https:' ? url.href : null; } catch (_) { return null; }
    }
    function imageForWidth(src, width) {
      try {
        var url = new URL(src);
        var shopify = url.hostname === 'cdn.shopify.com' && url.pathname.indexOf('/s/files/') === 0;
        var storefront = ['www.wheelsoutlet.com', 'wheelsoutlet.com'].includes(url.hostname) && url.pathname.indexOf('/cdn/shop/') === 0;
        if (url.protocol !== 'https:' || (!shopify && !storefront)) return src;
        url.searchParams.set('width', String(width)); return url.href;
      } catch (_) { return src; }
    }
    function sameFinishImage(match) {
      var name = finish(match);
      var direct = imageSource(match.variant.image); if (direct) return direct; if (!name) return null;
      var related = s.matches.find(function (other) { return productId(other) === productId(match) && finish(other) === name && imageSource(other.variant.image); });
      return related ? imageSource(related.variant.image) : null;
    }
    function money(variant) { return new Intl.NumberFormat(locale, { style: 'currency', currency: currency }).format(Number(variant.price)); }
    function card(group, index) {
      var wrapper = el('div', 'wo-result-item'), article = el('article', 'wo-product-card wo-editorial-card');
      article.dataset.productId = group.id;
      var imageLink = el('a', 'wo-editorial-image');
      var image = el('img', 'wo-card-image'); image.loading = index < 5 ? 'eager' : 'lazy'; image.decoding = 'async'; image.width = 640; image.height = 640;
      var placeholder = el('span', 'wo-vehicle-image-placeholder', t('image_unavailable'));
      imageLink.append(image, placeholder);
      var info = el('div', 'wo-editorial-info'), brandNode = el('p', 'wo-editorial-brand');
      var title = el('h2', 'wo-editorial-title'), titleLink = el('a'); title.append(titleLink);
      var price = el('p', 'wo-editorial-price'), amount = el('strong'), unit = el('small', '', t('price_unit', { currency: currency }));
      price.append(amount, unit);
      var size = el('p', 'wo-vehicle-card-size'), availability = el('p', 'wo-vehicle-card-availability');
      var plusSize = el('p', 'wo-vehicle-plus-size', t('plus_size')); plusSize.hidden = true;
      var finishes = el('div', 'wo-card-finishes'), selectedFinish = el('p', 'wo-vehicle-selected-finish'), swatches = el('div', 'wo-card-swatch-list wo-vehicle-swatches');
      finishes.append(selectedFinish, swatches); info.append(brandNode, title, price, size, plusSize, availability, finishes);
      article.append(imageLink, info); wrapper.append(article);
      var buttons = [], firstByFinish = new Map();
      group.variants.forEach(function (match) { var key = finish(match); if (key && !firstByFinish.has(key)) firstByFinish.set(key, match); });
      function update(match) {
        var variant = match.variant, spec = match.specification, name = finish(match), src = sameFinishImage(match);
        var label = t('size', { diameter: spec.diameter, width: spec.width, offset: spec.offset });
        var href = productUrl(variant);
        imageLink.href = href; titleLink.href = href; article.dataset.variantId = String(variant.id);
        imageLink.setAttribute('aria-label', t('view_wheel', { title: group.title, finish: name || t('finish_unknown'), size: label }));
        titleLink.setAttribute('aria-label', t('view_wheel', { title: group.title, finish: name || t('finish_unknown'), size: label }));
        brandNode.textContent = brand(match); titleLink.textContent = group.title; amount.textContent = money(variant); size.textContent = label;
        availability.textContent = variant.backorder ? t('backorder') : t('available');
        var diameterIncrease = Number(match.diameterIncrease);
        plusSize.hidden = !Number.isFinite(diameterIncrease) || diameterIncrease <= 0;
        selectedFinish.textContent = name || t('finish_unknown');
        image.hidden = !src; placeholder.hidden = Boolean(src);
        image.alt = t('wheel_image', { title: group.title, finish: name || t('finish_unknown') });
        if (src) {
          var responsive = imageForWidth(src, 320) !== src || imageForWidth(src, 640) !== src;
          if (responsive) {
            image.sizes = '(min-width:1440px) 18vw, (min-width:1200px) 22vw, (min-width:992px) 28vw, 43vw';
            image.srcset = [320, 480, 640].map(function (width) { return imageForWidth(src, width) + ' ' + width + 'w'; }).join(', ');
          } else { image.removeAttribute('srcset'); image.removeAttribute('sizes'); }
          image.src = imageForWidth(src, 480);
        } else { image.removeAttribute('src'); image.removeAttribute('srcset'); image.removeAttribute('sizes'); }
        buttons.forEach(function (entry) { entry.button.setAttribute('aria-pressed', String(entry.finish === name)); });
      }
      firstByFinish.forEach(function (match, name) {
        var swatch = el('button', 'wo-vehicle-swatch'); swatch.type = 'button'; swatch.title = name; swatch.setAttribute('aria-label', t('show_finish', { finish: name })); swatch.setAttribute('aria-pressed', 'false');
        var src = sameFinishImage(match);
        if (src) { var thumb = el('img'); thumb.src = imageForWidth(src, 100); thumb.alt = ''; thumb.loading = 'lazy'; thumb.width = 40; thumb.height = 40; swatch.append(thumb); }
        else swatch.append(el('span', '', name.slice(0, 2)));
        buttons.push({ button: swatch, finish: name }); swatches.append(swatch);
        swatch.addEventListener('mouseenter', function () { update(match); });
        swatch.addEventListener('focus', function () { update(match); });
        swatch.addEventListener('click', function (event) { event.preventDefault(); event.stopPropagation(); update(match); });
      });
      image.addEventListener('error', function () { image.hidden = true; placeholder.hidden = false; });
      update(group.variants[0]); return wrapper;
    }
    function render() {
      var diameterCount = s.filters.diameter.size;
      if (ui.mobileDiameterMultiple) {
        ui.mobileDiameterMultiple.hidden = diameterCount < 2;
        ui.mobileDiameterMultiple.textContent = t('selected_diameters', { count: diameterCount });
        ui.mobileDiameterSelect.value = diameterCount > 1 ? '__multiple' : diameterCount === 1 ? Array.from(s.filters.diameter)[0] : '';
      }
      s.groups = groups();
      var total = s.groups.length, pages = Math.max(1, Math.ceil(total / PAGE_SIZE)); s.page = Math.max(1, Math.min(s.page, pages));
      ui.layout.hidden = false; ui.count.textContent = t(total === 1 ? 'products_one' : 'products_other', { count: total.toLocaleString(locale) });
      ui.priceNote.hidden = s.priceRejected === 0; ui.priceNote.textContent = t('price_filtered', { currency: currency });
      ui.empty.hidden = total > 0; ui.empty.textContent = s.matches.length ? t('no_filter_results') : t('no_results');
      var fragment = document.createDocumentFragment();
      s.groups.slice((s.page - 1) * PAGE_SIZE, s.page * PAGE_SIZE).forEach(function (group, index) { fragment.append(card(group, index)); }); ui.grid.replaceChildren(fragment);
      ui.pager.hidden = pages <= 1; ui.page.textContent = t('page', { page: s.page, pages: pages }); ui.previous.disabled = s.page <= 1; ui.next.disabled = s.page >= pages;
    }
    function clearHiddenMobileFilters() {
      if (!mobileViewport.matches) return;
      var changed = s.filters.brand.size > 0 || s.filters.finish.size > 0;
      s.filters.brand.clear(); s.filters.finish.clear();
      ui.filterBody.querySelectorAll('input[data-wo-filter="brand"], input[data-wo-filter="finish"]').forEach(function (input) { input.checked = false; });
      if (changed) { s.page = 1; if (!ui.layout.hidden && !s.busy) render(); }
    }
    mobileViewport.addEventListener('change', clearHiddenMobileFilters);
    ui.cancel.addEventListener('click', function () { s.controller?.abort(); status(t('cancelled')); ui.errorText.textContent = t('cancelled'); ui.error.hidden = false; });
    ui.retry.addEventListener('click', function () { if (!s.busy && s.last) search(s.last, s.lastForce); });
    ui.refresh.addEventListener('click', function () { if (!s.busy && s.last) search(s.last, true); });
    ui.sort.addEventListener('change', function () { s.sort = ui.sort.value; s.page = 1; render(); });
    ui.mobileDiameterSelect.addEventListener('change', function () {
      var value = ui.mobileDiameterSelect.value; if (value === '__multiple') return;
      s.filters.diameter.clear(); if (value) s.filters.diameter.add(value);
      ui.filterBody.querySelectorAll('input[data-wo-filter="diameter"]').forEach(function (input) { input.checked = s.filters.diameter.has(input.value); });
      s.page = 1; render();
    });
    ui.clear.addEventListener('click', function () { Object.values(s.filters).forEach(function (set) { set.clear(); }); ui.filterBody.querySelectorAll('input').forEach(function (input) { input.checked = false; }); s.page = 1; render(); });
    ui.previous.addEventListener('click', function () { if (s.page > 1) { s.page--; render(); ui.layout.scrollIntoView({ block: 'start' }); } });
    ui.next.addEventListener('click', function () { if (s.page < Math.ceil(s.groups.length / PAGE_SIZE)) { s.page++; render(); ui.layout.scrollIntoView({ block: 'start' }); } });
    activeController = { search: search, clear: function () { clearResults(t('changed')); }, root: root };
    var url = new URL(location.href), nonce = url.searchParams.get('intent');
    if (nonce) {
      var intent = null;
      try { intent = JSON.parse(sessionStorage.getItem(INTENT_KEY) || 'null'); sessionStorage.removeItem(INTENT_KEY); } catch (_) { intent = null; }
      url.searchParams.delete('intent'); history.replaceState(history.state, '', url.pathname + url.search + url.hash);
      var intentDetail = validDetail(intent?.detail), urlVehicle = window.WOVehicleUrl?.read(url);
      var sameVehicle = intentDetail && urlVehicle && KEYS.every(function (key) { return urlVehicle[key] === intentDetail.vehicle[key]; });
      if (intent && intent.nonce === nonce && typeof intent.timestamp === 'number' && Date.now() - intent.timestamp >= 0 && Date.now() - intent.timestamp <= INTENT_TTL && sameVehicle) search(intentDetail, false);
      else status(t('expired'));
    } else discardIntent();
  }
  function discardIntent() {
    try { sessionStorage.removeItem(INTENT_KEY); } catch (_) {}
    var url = new URL(location.href);
    if (url.searchParams.has('intent')) {
      url.searchParams.delete('intent'); history.replaceState(history.state, '', url.pathname + url.search + url.hash);
    }
  }
  function initWithin(root) {
    if (root.matches?.('[data-wo-vehicle-results]')) initialize(root);
    root.querySelectorAll('[data-wo-vehicle-results]').forEach(initialize);
  }
  document.addEventListener('wo:vehicle-submit', function (event) {
    var detail = validDetail(event.detail); if (!detail) return;
    event.preventDefault();
    if (activeController && document.contains(activeController.root)) {
      if (!window.WOVehicleUrl?.write(detail)) return;
      discardIntent(); activeController.search(detail, false); return;
    }
    var nonce = typeof crypto.randomUUID === 'function' ? crypto.randomUUID() : String(Date.now()) + '-' + Math.random().toString(36).slice(2);
    try { sessionStorage.setItem(INTENT_KEY, JSON.stringify({ nonce: nonce, timestamp: Date.now(), detail: detail })); }
    catch (_) { var status = event.target.closest('[data-wo-vehicle-picker]')?.querySelector('[role="status"]'); if (status) status.textContent = STRINGS.storage_error; return; }
    var destination = new URL('/collections/wheels', location.origin);
    destination.searchParams.set('view', 'vehicle'); destination.searchParams.set('intent', nonce);
    var preview = new URL(location.href).searchParams.get('preview_theme_id'); if (preview) destination.searchParams.set('preview_theme_id', preview);
    destination = window.WOVehicleUrl?.withVehicle(detail, destination);
    if (!destination) { discardIntent(); return; }
    location.assign(destination.pathname + destination.search + destination.hash);
  });
  document.addEventListener('change', function (event) {
    if (!event.target.closest?.('[data-wo-vehicle-picker]')) return;
    discardIntent(); window.WOVehicleUrl?.clear();
    if (activeController && document.contains(activeController.root)) activeController.clear();
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initWithin(document); }, { once: true });
  else initWithin(document);
  document.addEventListener('shopify:section:load', function (event) { initWithin(event.target); });
})();
})();
